import type { z } from 'zod';
import { absenceSchema } from '@/schemas/API/GET/employee/absence/response';

export const createAbsenceSchema = absenceSchema.omit({
  id: true,
  confirm: true,
});

export type CreateAbsence = z.infer<
  typeof createAbsenceSchema
>;